export default "__VITE_ASSET__DbooyQYI__"